module.exports = __webpack_public_path__ + "src/img/zalando/img-zalando-websites-1.2fc61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-zalando-websites-1.jpg
// module id = 128
// module chunks = 0